import { CloudinaryImage } from '#src/components/CloudinaryImage';
import { flattenResponsiveImage } from '#src/lib/contentful/selectors.mjs';

import styles from './TestimonialCarousel.Card.scss';

export function TestimonialCard({ profileImage, quote, name }) {
  return (
    <div className={styles.container}>
      <div className={styles.nameContainer}>
        <CloudinaryImage
          {...flattenResponsiveImage(profileImage)}
          className={styles.image}
          draggable={false}
        />
        <p className={styles.name}>{name}</p>
      </div>

      <p className={styles.quote}>{quote}</p>
    </div>
  );
}
